"use strict";
export const sendAnalyticsEvent = () => {
};
export const setUserProperty = () => {
};
export const logSwapQuoteFetch = () => {
};
export const trace = () => {
};
export const Trace = ({ children, ...props }) => children;
export const analytics = {
  init: () => Promise.resolve(),
  track: () => {
  },
  setUserProperty: () => {
  },
  identify: () => {
  },
  reset: () => {
  },
  get: () => void 0,
  set: () => {
  },
  // Add any other methods that might be called
  flush: () => Promise.resolve(),
  add: () => {
  },
  remove: () => {
  },
  update: () => {
  }
};
export const analyticsFunction = () => analytics;
export const analyticsCallable = Object.assign(() => analytics, analytics);
export const getAnalyticsAtomDirect = () => Promise.resolve(false);
